<script>
import { mapState } from 'vuex';

import campaignsEnum from './_campaigns-enum';
import clientMixins from 'utils/client-mixins';
import navigationHelper from 'utils/navigation-helper';
import { privileges } from 'domains/base/_base-enum';

export default {
  name: 'Campaign',
  mixins: [clientMixins],
  props: {
    campaignId: String,
  },
  data: () => ({
    ready: false,
  }),
  computed: mapState({
    currentCampaign: state => state.campaigns.currentCampaign,
    currentUserRoleInfo: state => state.currentUserRoleInfo,
  }),
  beforeRouteEnter(to, from, next) {
    if (from.name) navigationHelper.setCampaignsBackPath(from.path);

    next();
  },
  async created() {
    if (this.hasPrivilege(privileges.CAMPAIGN_DETAILS)) {

      // not using async await or Promise.all because ads is allowed to fail, info tab data is not
      // async await would block tab data from being called in parallel
      this.$store.dispatch('getTabData', { campaignId: this.campaignId, tab: campaignsEnum.AD_FACTORY })
        .then(() => navigationHelper.routeChanged(this.$route, '', this.currentUserRoleInfo))
        .catch((e) => {
          if (this.$route.name === 'campaignsAds') {
            this.$router.replace({ name: 'campaigns' });
          }
        });

      try {
        this.$store.commit('setCurrentCampaign', { property: 'cache.info', value: false });
        this.$store.commit('setCurrentCampaign', { property: campaignsEnum.INFO, value: {}, tab: campaignsEnum.INFO });
        this.$store.commit('resetEligibleUpsells');
        await Promise.all([
          this.$store.dispatch('getTabData', { campaignId: this.campaignId, tab: campaignsEnum.INFO }),
          this.$store.dispatch('getCampaignCategories'),
        ]);
        this.ready = true;
      } catch (e) {
        this.$router.replace('/');
      }
    }
  },
  methods: {
    $_handleAdFactoryRedirect() {
      if (this.$route.name === 'campaignsAds') {
        if (this.hasPrivilege(privileges.CAMPAIGN_DETAILS)) {
          this.$router.replace({ name: 'campaignsDetails' });
        } else {
          this.$router.replace('/');
        }
      }
    },
  },
};
</script>

<template lang='pug'>
.campaign(:class='{ "campaign--full-height": $route.name === "campaignsAds" }')
  h5.campaign__name(:class='{ "campaign__name--absolute": $route.name === "campaignsAds" }') {{currentCampaign.info.name}}
  router-view(v-if='ready')
</template>

<style>
@import '~import/index';

.campaign {
  &--full-height {
    height: 100%;
  }

  &__name {
    margin: 1rem 0 0 0;

    @include mq(mf-md) {
      margin: 1rem 0 -2rem 1rem;
    }

    @include mq(mf-lg) {
      margin: 2rem 0 -2rem 2rem;
    }

    @include mq(mf-xl) {
      margin: 2rem 0 -2rem 6rem;
    }

    &--absolute {
      position: absolute;
      top: 0;
      right: 0;
      background-color: $white;
      margin: 0;
      width: 175px;
      font-size: $h5;
      padding: 1rem;

      @include mq(mf-md) {
        width: auto;
        top: 0;
        right: 0;
      }
    }
  }
}

.vs-alert--campaign {
  padding: 0;
  margin-bottom: 1rem;
}
</style>
